import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loadAwards } from '../../redux/actions/awards';
import { getAllAwards } from '../../redux/selectors/awards';
import { getInfo } from '../../redux/selectors/info';
import { css, withStyles } from '../../assets/styles/withStyles';
import { getImageUrl } from '../../utils';

class About extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.props.loadAwards();
  }

  _renderAwards() {
    const { styles, awards } = this.props;

    return awards.map(award => (
      <div key={award.id} {...css(styles.awardWrapper)}>
        <div {...css(styles.awardYearWrapper)}>
          <p {...css(styles.awardYear)}>
            {award.year.toString().padStart(3, '0')}
          </p>
        </div>
        <div>
          <p {...css(styles.awardText)}>{award.text}</p>
        </div>
      </div>
    ));
  }

  _renderInfo() {
    const { styles, info } = this.props;

    if (!info) return null;

    return (
      <div>
        <p {...css(styles.text)}>{info.text}</p>
        <img
          alt={info.text}
          src={getImageUrl(info.image)}
          {...css(styles.image)}
        />
      </div>
    );
  }

  render() {
    const { styles } = this.props;

    return (
      <div {...css(styles.container)}>
        <div {...css(styles.leftSide)}>{this._renderInfo()}</div>
        <div {...css(styles.rightSide)}>{this._renderAwards()}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  awards: getAllAwards(state),
  info: getInfo(state)
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      loadAwards
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(({ breakpoints }) => ({
    container: {
      paddingTop: 76,

      [breakpoints.md]: {
        paddingTop: 0,
        position: 'fixed',
        top: 0,
        right: 0,
        left: '33%',
        bottom: 0,
        overflow: 'scroll'
      }
    },
    leftSide: {
      padding: 15,

      [breakpoints.md]: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 15,
        paddingRight: 15,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '50%',
        overflow: 'scroll',
        borderRightStyle: 'solid',
        borderRightWidth: 2,
        borderRightColor: 'black'
      }
    },
    rightSide: {
      padding: 15,

      [breakpoints.md]: {
        padding: 20,
        position: 'absolute',
        width: '50%',
        top: 0,
        right: 0,
        bottom: 0,
        overflow: 'scroll'
      }
    },
    text: {
      marginBottom: 20,
      whiteSpace: 'pre-line',
      fontSize: 16,
      lineHeight: '20px',

      [breakpoints.sm]: {
        fontSize: 26,
        lineHeight: '30px'
      },

      [breakpoints.lg]: {
        fontSize: 27,
        lineHeight: '33px'
      }
    },
    awardWrapper: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 20
    },
    awardYearWrapper: {
      width: 50,
      flexShrink: 0
    },
    awardYear: {
      fontSize: 17,
      lineHeight: '20px'
    },
    awardText: {
      paddingLeft: 20,
      fontSize: 17,
      lineHeight: '20px',
      whiteSpace: 'pre-line'
    },
    image: {
      width: '100%',
      padding: 30
    }
  }))(About)
);



// WEBPACK FOOTER //
// ./src/containers/About/index.js